import request from "@/utils/request";
//1, 新建预约
export function newAppointment(data){
    return request({
        url:'/web/newAppointment',
        data:data,
        method:'post'
    })
}
//2, 我的预约列表
export function myAppointment(data){
    return request({
        url:'/web/myAppointment',
        data:data,
        method:'get'
    })
}

// 3, 取消预约
export function cancelAppointment(data){
    return request({
        url:'/web/cancelAppointment',
        data:data,
        method:'post'
    })
}

//4, 用户收藏设备的列表
export function myCollectDevices(data){
    return request({
        url:'/web/myCollectDevices',
        data:data,
        method:'get'
    })
}

//5, 取消收藏
export function uncollectDevice(data){
    return request({
        url:'/web/uncollectDevice',
        data:data,
        method:'post'
    })
}

